import { render } from "./Admin.vue?vue&type=template&id=611bbfde&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=611bbfde&scoped=true&lang=css"
import "./Admin.vue?vue&type=style&index=1&id=611bbfde&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611bbfde"]])

export default __exports__